// Add a console.log object if one doesn't exist yet
var console = window.console || { log: function () { } }; //browser console fix